import { useEffect, useState } from 'react'

import { AddressFormValidations, deliveryMethods } from '@reveni-io/reveni-ui'

import { updateAddressField } from '@/common/helpers/helpers'

const useChangeDeliveryMethod = ({ currentDeliveryMethod, currentAddress, availableDeliveryMethods }) => {
  const [deliveryMethodSelected, setDeliveryMethodSelected] = useState(null)
  const [newAddress, setNewAddress] = useState(null)
  const [selectedPickupDate, setSelectedPickupDate] = useState(null)
  const [selectedTimeRange, setSelectedTimeRange] = useState(null)
  const [createNewLabel, setCreateNewLabel] = useState(false)
  const [discardLabels, setDiscardLabels] = useState(false)

  useEffect(() => {
    if (currentAddress) {
      setNewAddress({
        ...currentAddress,
        phone: {
          prefix: currentAddress?.phone?.prefix || currentAddress?.country?.phone_code,
          number: currentAddress?.phone?.number || '',
        },
      })
    }
  }, [currentAddress])

  useEffect(() => {
    const deliveryMethod = availableDeliveryMethods?.find(
      deliveryMethod => deliveryMethod.id === currentDeliveryMethod?.id
    )

    if (deliveryMethod) {
      setDeliveryMethodSelected(deliveryMethod)
    }
  }, [availableDeliveryMethods, currentDeliveryMethod])

  const onChangeDeliveryMethod = e => {
    const deliveryMethod = availableDeliveryMethods.find(deliveryMethod => deliveryMethod.id === e.target.value)
    setDeliveryMethodSelected(deliveryMethod)
    setSelectedPickupDate(null)
    setSelectedTimeRange(null)
    setCreateNewLabel(false)

    //We need to initialize the house number field if the new delivery method requires it to avoid some visual errors in the house number field
    if (deliveryMethod.requires_house_number) {
      setNewAddress({
        ...newAddress,
        house_number: newAddress?.house_number || '',
      })
    }
  }

  const handleAddressChange = e => {
    const { name, value } = e.target

    setNewAddress(updateAddressField(newAddress, name, value))
  }

  const getPhoneNumber = () => {
    return `+${newAddress?.phone?.prefix} ${newAddress?.phone?.number}`
  }

  const isFormValid = () => {
    if (deliveryMethodSelected?.type === deliveryMethods.customerpickup) {
      return AddressFormValidations.isFormValid({
        deliveryMethod: { ...deliveryMethodSelected, requires_address: true },
        address: newAddress,
        timeRange: selectedTimeRange,
        isProvinceRequired: false,
        phone: getPhoneNumber(),
        specialConstraints: deliveryMethodSelected?.configuration,
        pickupDate: selectedPickupDate,
      })
    }

    return true
  }

  return {
    deliveryMethodSelected,
    setDeliveryMethodSelected,
    newAddress,
    setNewAddress,
    specialConstraints: deliveryMethodSelected?.configuration,
    selectedPickupDate,
    setSelectedPickupDate,
    selectedTimeRange,
    setSelectedTimeRange,
    createNewLabel,
    setCreateNewLabel,
    onChangeDeliveryMethod,
    isFormValid,
    handleAddressChange,
    discardLabels,
    setDiscardLabels,
  }
}

export default useChangeDeliveryMethod
